import { getConfig } from '@klpkonsern/appconfig';
import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klp/routing';

// Extend AppConfigParameters for this module
declare global {
    interface AppConfigParameters {
        WEBAPP_SUPPORT_FORM_ENABLE: boolean;
    }
}

// Helper functions
export const getSupportFormEnable = (): boolean =>
    getConfig('WEBAPP_SUPPORT_FORM_ENABLE', false);

export const SupportFormModuleName = 'support/covid19';

export const SupportFormRoutes = {
    moduleRoute: () => generateRoute([SupportFormModuleName]),
    form: () => generateRoute([SupportFormModuleName, 'form']),
    formAdd: (formId: string) =>
        generateRoute([SupportFormModuleName, formId, 'form']),
    formView: (formId?: string | number) =>
        generateRoute([SupportFormModuleName, formId]),
};

export const SupportFormAccess = (): boolean => getSupportFormEnable();

export const SupportFormMenuItems = [
    new SidebarMenuItem({
        route: SupportFormRoutes.form(),
        matchRoute: SupportFormRoutes.moduleRoute(),
        icon: IconName.DOC_INTERNAL,
        translation: 'supportForm.title',
        access: SupportFormAccess,
    }),
];
